<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="isCreate ? newRules: updateRules"
          ref="ruleForm"
          class="flex flex-row w-full"
          autocomplete="off"
        >
          <div class="flex-1 hideHScroll">

          <base-collapsible-form 
            ref="baseCollapsibleDatosGeneral" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{"Datos del cliente"}}</h2>
            </template>
            <template slot="content">

            <div class="lg:mb-2" v-if="role === 'SuperAdministrador'">
              
              <accessible-el-select
                prop="idDistribuidor"
                v-model="form.idDistribuidor"
                :options="distribuidores.map(dist => ({ id: dist.IdDistribuidor, value: dist.IdDistribuidor, name: dist.Nombre }))"
                id-prefix="clients"
                :isDisabled="!isCreate"
              >
                <template #label>
                  {{ $t('distributors.distributor') }}
                </template>
              </accessible-el-select>
              
            </div>

            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('clients.name')}}
                  <el-form-item prop="name">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.name"
                      maxlength='100'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.EmailsContacto')}}
                  <el-form-item prop="EmailsContacto">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailsContacto"
                      maxlength='500'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.cod_ext')}}
                  <el-form-item prop="codigoExterno">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.codigoExterno"
                      maxlength='20'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>
            <div class="lg:mb-2" v-if="!isCreate">
              <div class="mandatory">
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.ns')}}
                  <el-form-item prop="ns">
                    <el-input
                      :disabled="!isCreate"
                      clearable
                      class="w-full"
                      v-model="form.ns"
                      maxlength='50'
                    />
                  </el-form-item>
                </label>
              </div>
            </div>

            <div class="lg:mb-2" v-if="!isCreate || (role === 'SuperAdministrador')">
              <AccessibleElSelect
                v-model="form.partnerId"
                prop="partnerId"
                :options="partnersForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="!isCreate"
                :allowCreate="true"
                maxlength="50"
                placeholder="Seleccionar"
                id-prefix="clients"
              >
                <template slot="label">
                  <div class="flex items-center">
                    <div>
                      <base-obligatory-icon v-if="isCreate"/>{{$t('clients.partner')}}
                    </div>
                    <base-tooltip-icon 
                      size="sm" 
                      content="Seleccione un partner existente o escriba el nombre de uno nuevo y selecciónelo" 
                      class="ml-2"/>
                  </div>
                  </template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.grupoVigilanteId"
                prop="grupoVigilanteId"
                :options="gruposVigilanteForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="!isCreate"
                id-prefix="clients"
              >
                <template slot="label"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.grupo_vigilante')}}</template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2" v-if="!isCreate">
              <AccessibleElSelect
                v-model="form.tipoServicio"
                prop="tipoServicio"
                :options="tiposServicioForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="true"
                id-prefix="clients"
              >
                <template slot="label"><base-obligatory-icon v-if="isCreate"/>{{$t('clients.service_type')}}</template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2" v-if="!isCreate">
              <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.fecha_alta')}}
                <el-form-item prop="FechaAlta">
                  <el-date-picker
                    class="bg-white dark:bg-darkblue-900"
                    v-model="form.FechaAlta"
                    :picker-options="dateRangeOptions"
                    type="date"
                    format="dd-MM-yyyy"
                    :disabled="role !== 'SuperAdministrador'"
                    placeholder="dd-mm-aaaa"
                    ref="datePickerFechaAlta"
                    @blur="onBlurDatePickerMixin('.datePickerFechaAlta-popover')"
                    @focus="onFocusDatePickerMixin('.datePickerFechaAlta-popover')"
                    @keydown.native="captureKeyNotChrome"
                    popper-class="datePickerFechaAlta-popover"
                    >
                  </el-date-picker>
                </el-form-item>
              </label>
            </div>

            <div class="lg:mb-2" v-if="!isCreate">
              <AccessibleElSelect
                v-model="form.TipoHSM"
                prop="TipoHSM"
                :options="tiposHSMForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="role !== 'SuperAdministrador'"
                id-prefix="clients"
              >
                <template slot="label"><base-obligatory-icon v-if="role === 'SuperAdministrador'"/>{{$t('clients.tipo_hsm')}}</template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2" v-if="!isCreate">
              <AccessibleElSelect
                v-model="form.idTipoCliente"
                prop="idTipoCliente"
                :options="tiposClienteForAccessibleSelect"
                :withFormItem="true"
                :isDisabled="role !== 'SuperAdministrador'"
                id-prefix="clients"
              >
                <template slot="label"><base-obligatory-icon v-if="role === 'SuperAdministrador'"/>{{$t('clients.tipo_cliente')}}</template>
              </AccessibleElSelect>
            </div>

            <div class="lg:mb-2" v-if="!isCreate">
              <div class="flex flex-col lg:flex-row w-full gap-x-4">
                <AccessibleElSelect
                  class="w-full"
                  v-model="form.MaquinasNuestras"
                  prop="MaquinasNuestras"
                  :options="tiposMaquinasNuestrasForAccessibleSelect"
                  :withFormItem="true"
                  :isDisabled="role !== 'SuperAdministrador'"
                  id-prefix="clients"
                >
                  <template slot="label"><base-obligatory-icon v-if="role === 'SuperAdministrador'"/>{{$t('clients.maquinas_nuestras')}}</template>
                </AccessibleElSelect>
                <label class="w-full dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.fecha_migracion_solpheo')}}
                  <el-form-item prop="FechaMigracionSolpheo">
                    <el-date-picker
                      class="bg-white dark:bg-darkblue-900"
                      v-model="form.FechaMigracionSolpheo"
                      :picker-options="dateRangeOptions"
                      type="date"
                      format="dd-MM-yyyy"
                      :disabled="role !== 'SuperAdministrador'"
                      placeholder="dd-mm-aaaa"
                      ref="datePickerFechaMigracionSolpheo"
                      @blur="onBlurDatePickerMixin('.datePickerFechaMigracionSolpheo-popover')"
                      @focus="onFocusDatePickerMixin('.datePickerFechaMigracionSolpheo-popover')"
                      @keydown.native="captureKeyNotChrome"
                      popper-class="datePickerFechaMigracionSolpheo-popover"
                      >
                    </el-date-picker>
                  </el-form-item>
                </label>
              </div>
            </div>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleConfigGeneral" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('clients.config_general')}}</h2>
            </template>
            <template slot="content">

            <div v-if="hasModuleCustomDownloadZIP && !isCreate">
              <div class="flex flex-col lg:flex-row justify-between">              
                <div class="w-full">
                  <label for="id-switch-configDownloadZIP" class="w-full text-sm font-semibold text-secondary-600 flex flex-col">
                    {{$t('clients.config_download_zip')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                  </label>
                  <el-switch 
                    id="id-switch-configDownloadZIP"
                    :aria-label="$t('clients.config_download_zip')"
                    class="switch-text break-normal both-switch mt-2" 
                    v-model="form.configDownloadZIP" 
                    :active-text="$t('companies.active')"/>
                </div>
                <div class="w-full mt-2 lg:mt-0 font-semibold">
                  <div class="flex flex-row items-center">
                    <label class="text-sm font-semibold text-secondary-600">{{$t('clients.zip_max_size')}}
                    </label>
                    <base-tooltip-icon 
                      size="sm" 
                      :content="$t('tooltip.client.zip_max_size')" 
                      class="ml-2"/>
                  </div>
                    <el-form-item prop="maxSizeZIP" class="mt-2">
                      <el-input
                        clearable
                        class="w-full"
                        v-model.number="form.maxSizeZIP"
                        maxlength='2'
                        >
                        <template slot="append">MB</template>
                      </el-input>
                    </el-form-item>
                </div>        
              </div>
            </div>

            <div v-if="hasModuleCustomDownloadZIP && !isCreate" class="mb-2">
              <div class="flex flex-col lg:flex-row justify-between gap-x-2">              
                <div class="w-full">
                  <label for="id-switch-configZipMailDownload" class="w-full text-sm font-semibold text-secondary-600 flex flex-col">
                    {{$t('clients.check_mail_zip_download')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                  </label>         
                  <el-switch 
                    id="id-switch-configZipMailDownload"
                    :aria-label="$t('clients.check_mail_zip_download')"
                    class="switch-text break-normal both-switch mt-2 mb-4" 
                    v-model="form.configZipMailDownload" 
                    :active-text="$t('companies.active')"/>
                </div>
                <div class="w-full">
                  <label for="id-switch-configZipMailVinc" class="w-full text-sm font-semibold text-secondary-600 flex flex-col">
                    {{$t('clients.check_mail_zip_vinc')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                  </label>         
                  <el-switch 
                    id="id-switch-configZipMailVinc"
                    :aria-label="$t('clients.check_mail_zip_vinc')"
                    class="switch-text break-normal both-switch mt-2 mb-4" 
                    v-model="form.configZipMailVinc" 
                    :active-text="$t('companies.active')"/>
                </div>
                <div class="w-full">
                  <label for="id-switch-configZipMailManual" class="w-full text-sm font-semibold text-secondary-600 flex flex-col">
                    {{$t('clients.check_mail_zip_manual')}}
                    <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                  </label>         
                  <el-switch 
                    id="id-switch-configZipMailManual"
                    :aria-label="$t('clients.check_mail_zip_manual')"
                    class="switch-text break-normal both-switch mt-2 mb-4" 
                    v-model="form.configZipMailManual" 
                    :active-text="$t('companies.active')"/>
                </div>  
              </div>
            </div>

            <div v-if="hasModuleCustomDownloadZIP && !isCreate">
              <label class="text-sm font-semibold text-secondary-600 block">
                <div class="flex items-center">
                  {{$t('clients.rename_zip')}}
                  <base-tooltip-icon 
                    size="sm" 
                    :content="$t('tooltip.client.placeholderRenameZIP')" 
                    class="ml-2"/>
                </div>
                <div class="flex justify-between">              
                  <el-form-item prop="renameZip" class="w-full">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.renameZip"
                      maxlength='300'
                    />
                  </el-form-item>
                  <base-button 
                    class="ml-4 mt-1" 
                    style="width: 220px"
                    mode="primary" 
                    :text="$t('clients.new_metadata')" 
                    @click.prevent.stop="toggleInsertTag" 
                    :loading="isGeneralLoading"/>
                </div>
              </label>
            </div>
            
            <div class="mb-4 w-full lg:w-6/12 " v-if="!isCreate">
              <label class="text-sm font-semibold text-secondary-600">{{$t('clients.DiasFechaFinTramite')}}
                <el-form-item prop="DiasFechaFinTramite" class="mt-2">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.DiasFechaFinTramite"
                    maxlength='2'
                    :placeholder="$t('configurations.default_disabled')"
                    >
                    <template slot="append">días</template>
                  </el-input>
                </el-form-item>
              </label>
            </div>

            <div class="mb-4" v-if="!isCreate">
              <label for="id-switch-visibility" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.edit_visibility')}}
                <span class="sr-only">Opciones: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>  
              </label>
              <el-switch 
                id="id-switch-visibility"
                :aria-label="$t('clients.edit_visibility')"
                :disabled="role !== 'SuperAdministrador' && role !== 'SuperAdminDistribuidor'"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.editVisilibity" 
                :active-text="$t('companies.active')"/>
            </div>

            <div class="mb-4" v-if="hasModuleDescargaAdjuntosPrincipales && !isCreate">
              <label for="id-switch-module_descarga_adjuntos_princ" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.module_descarga_adjuntos_princ')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
              </label>
              <el-switch 
                id="id-switch-module_descarga_adjuntos_princ"
                :aria-label="$t('clients.module_descarga_adjuntos_princ')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.DescargarSoloAdjuntosPrincipales" 
                :active-text="$t('companies.active')"/>
            </div>
                  
            <div class="mb-4">
              <label for="id-switch-gestionar_lista_blanca_grupos" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.gestionar_lista_blanca_grupos')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('app.client')}} / {{$t('app.groups')}}</span>
              </label>
              <el-switch 
                id="id-switch-gestionar_lista_blanca_grupos"
                :aria-label="$t('clients.gestionar_lista_blanca_grupos')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.GestionarListaBlancaGrupos" 
                :active-text="$t('app.groups')"
                :inactive-text="$t('app.client')"
                inactive-color="var(--primary-800)"/>
            </div>

            <div class="mb-4">
              <label for="id-switch-descargar_acuse" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.descargar_acuse')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
              </label>
              <el-switch 
                id="id-switch-descargar_acuse"
                :aria-label="$t('clients.descargar_acuse')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.descargarAcusePDF" 
                :active-text="$t('companies.active')"/>
            </div>

            <div class="mb-4" v-if="!isCreate">
              <label for="id-switch-ocultar-info" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.ocultar_info_empresas_certificados')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
              </label>
              <el-switch 
                id="id-switch-ocultar-info"
                :aria-label="$t('clients.ocultar_info_empresas_certificados')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.OcultarInformacionEmpresasCertificados" 
                :active-text="$t('companies.active')"/>
            </div>
            
            <div class="mb-4" v-if="!isCreate">
              <label for="id-switch-enviar_correo_solo_descarga_automatica" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.enviar_correo_solo_descarga_automatica')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
              </label>
              <el-switch 
                id="id-switch-enviar_correo_solo_descarga_automatica"
                :aria-label="$t('clients.enviar_correo_solo_descarga_automatica')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.EnviarCorreoSoloDescargaAutomatica" 
                :active-text="$t('companies.active')"/>
            </div>
                  
            <div class="mb-4" v-if="!isCreate && hasModuleNotificacionesTerceros">
              <label for="id-switch-gestionar_notificaciones_terceros" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.gestionar_notificaciones_terceros')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('app.basic')}} / {{$t('app.advanced')}}</span>
              </label>
              <el-switch 
                id="id-switch-gestionar_notificaciones_terceros"
                :aria-label="$t('clients.gestionar_notificaciones_terceros')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.TercerosAvanzado" 
                :active-text="$t('app.advanced')"
                :inactive-text="$t('app.basic')"
                inactive-color="var(--primary-800)"/>
            </div>

            <div class="mb-4" v-if="!isCreate">
              <label for="id-switch-ocultar_enlace_descarga" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.ocultar_enlace_descarga')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
              </label>
              <el-switch 
                id="id-switch-ocultar_enlace_descarga"
                :aria-label="$t('clients.ocultar_enlace_descarga')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.OcultarEnlaceDescarga" 
                :active-text="$t('companies.active')"/>
            </div>

            <div class="mb-4" v-if="!isCreate">
              <label for="id-switch-tramitar-diligencias-contestadas" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.tramitar_diligencias_contestadas')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
              </label>
              <el-switch 
                id="id-switch-tramitar-diligencias-contestadas"
                :aria-label="$t('clients.tramitar_diligencias_contestadas')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.TramitarDiligenciasContestadas" 
                :active-text="$t('companies.active')"/>
            </div>

            <div class="mb-4">
              <label for="id-switch-status" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('clients.status')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
              </label>
              <el-switch 
                id="id-switch-status"
                :aria-label="$t('clients.status')"
                :disabled="disableTipoLibre"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.activo" 
                :active-text="$t('companies.active')"/>
            </div>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            ref="baseCollapsibleLicenciamiento" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{"Datos de licenciamiento"}}</h2>
            </template>
            <template slot="content">
            
            <div class="lg:mb-0">
              <div class="flex -mx-2 flex-col lg:flex-row items-end">
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('distributors.num_neos')}}
                    <el-form-item prop="NumNEOs">
                      <el-input
                        :disabled="disableLicenciamiento"  
                        clearable
                        class="w-full"
                        v-model.number="form.NumNEOs"
                        maxlength='7'
                      >
                      </el-input>
                    </el-form-item>
                  </label>
                </div>
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('distributors.stored_space')}}
                    <el-form-item prop="StoredSpace">
                      <el-input
                        :disabled="disableLicenciamiento"  
                        clearable
                        class="w-full"
                        v-model.number="form.StoredSpace"
                        maxlength='7'
                      >
                        <template slot="append">MB</template>
                      </el-input>
                    </el-form-item>
                  </label>
                </div>
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_sms')}}
                    <el-form-item prop="NumSMS">
                      <el-input
                        :disabled="disableLicenciamiento"  
                        clearable
                        class="w-full"
                        v-model.number="form.NumSMS"
                        maxlength='7'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>
            </div>

            <div class="lg:mb-0">
              <div class="flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('clients.num_locations')}}
                    <el-form-item prop="NumLocations">
                      <el-input
                      :disabled="disableLicenciamiento"  
                        clearable
                        class="w-full"
                        v-model.number="form.NumLocations"
                        maxlength='4'
                      />
                    </el-form-item>
                  </label>
                </div>
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('clients.num_companies')}}
                    <el-form-item prop="NumCompanies">
                      <el-input
                        :disabled="disableLicenciamiento"  
                        clearable
                        class="w-full"
                        v-model.number="form.NumCompanies"
                        maxlength='7'
                      />
                    </el-form-item>
                  </label>
                </div>
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_pgncif')}}
                    <el-form-item prop="NumeroSedesxCIFEmpresas">
                      <el-input
                        :disabled="disableLicenciamiento"  
                        clearable
                        class="w-full"
                        v-model.number="form.NumeroSedesxCIFEmpresas"
                        maxlength='7'
                      />
                    </el-form-item>
                  </label>
                </div>
                <div class="px-2 w-full lg:mb-0">
                  <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('clients.num_users')}}
                    <el-form-item prop="NumUsers">
                      <el-input
                        :disabled="disableLicenciamiento"  
                        clearable
                        class="w-full"
                        v-model.number="form.NumUsers"
                        maxlength='4'
                      />
                    </el-form-item>
                  </label>
                </div>
              </div>
            </div>

            <div v-if="!isCreate">
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_neos')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ stats.NumNEOs }} / {{ stats.NumNEOsTotal }}</span>
                  <el-progress :aria-label="$t('distributors.num_neos')" class="w-full dark:text-darkblue-200" :percentage="percentageNumNEOs" :color="customColorMethod"></el-progress>
                </div>                
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.stored_space')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ stats.StoredSpace }} / {{ stats.StoredSpaceTotal }}</span>
                  <el-progress :aria-label="$t('distributors.stored_space')" class="w-full dark:text-darkblue-200" :percentage="percentageStoredSpace" :color="customColorMethod"></el-progress>
                </div>                
              </div>
              <div class="mb-4" v-if="stats.NumSMSTotal">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('distributors.num_sms')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ stats.NumSMS }} / {{ stats.NumSMSTotal }}</span>
                  <el-progress :aria-label="$t('distributors.num_sms')" class="w-full dark:text-darkblue-200" :percentage="percentageNumSMS" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_companies')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ stats.NumCompanies }} / {{ stats.NumCompaniesTotal }}</span>
                  <el-progress :aria-label="$t('clients.num_companies')" class="w-full dark:text-darkblue-200" :percentage="percentageNumCompanies" :color="customColorMethod"></el-progress>
                </div>                
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_pgncif')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ stats.NumeroSedesxCIFEmpresas }} / {{ stats.NumeroSedesxCIFEmpresasTotal }}</span>
                  <el-progress :aria-label="$t('clients.num_pgncif')" class="w-full dark:text-darkblue-200" :percentage="percentageNumeroSedesxCIFEmpresas" :color="customColorMethod"></el-progress>
                </div>
              </div>
              <div class="mb-4">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.num_users')}}</label>
                <div class="flex flex-row mt-2">
                  <span class="w-32 text-sm text-secondary-600 dark:text-darkblue-200">{{ stats.NumUsers }} / {{ stats.NumUsersTotal }}</span>
                  <el-progress :aria-label="$t('clients.num_users')" class="w-full dark:text-darkblue-200" :percentage="percentageNumUsers" :color="customColorMethod"></el-progress>
                </div>
              </div>
            </div>

            <div class="mb-4" v-if="!isCreate && form.FechaFacturacion">
                <base-ro-input-minimal :label="$t('clients.alta_fact')" :data="form.FechaFacturacion"/>
            </div>

            </template>
          </base-collapsible-form>

              <base-collapsible-form 
                ref="baseCollapsibleConfigMails" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{msgHeaderConfigMails}}</h2>
                </template>
                <template slot="content">
                    <div class="mb-4">
                      <label for="id-switch-daysGroupsCompanies" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('clients.config_days_groups_companies')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('app.companies')}} / {{$t('app.groups')}}</span>
                      </label>
                      <el-switch 
                        id="id-switch-daysGroupsCompanies"
                        :aria-label="$t('clients.config_days_groups_companies')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="form.daysGroupsCompanies" 
                        :inactive-text="$t('app.companies')" 
                        :active-text="$t('app.groups')"
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                    
                    <div class="mb-4">
                      <label for="id-switch-mailsGroupCompanies" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('clients.config_mails_groups_gestion')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                      </label>
                      <el-switch 
                        id="id-switch-mailsGroupCompanies"
                        :aria-label="$t('clients.config_mails_groups_gestion')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="form.mailsGroupCompanies" 
                        :active-text="$t('app.active')" 
                        />
                    </div>
                    
                    <div class="mb-4">
                      <label for="id-switch-mailsTo" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('clients.config_mails_to')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('configurations.mails_to')}} / {{$t('configurations.mails_bcc')}}</span>
                      </label>
                      <el-switch 
                        id="id-switch-mailsTo"
                        :aria-label="$t('clients.config_mails_to')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="form.mailsTo" 
                        :active-text="$t('configurations.mails_bcc')"
                        :inactive-text="$t('configurations.mails_to')"
                        inactive-color="var(--primary-800)"
                        />
                    </div>
                    
                    <div class="mb-4">
                      <label for="id-switch-TramitarAuto" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                        {{$t('clients.config_mails_tramitar_auto')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                      </label>
                      <el-switch 
                        id="id-switch-TramitarAuto"
                        :aria-label="$t('clients.config_mails_tramitar_auto')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="form.TramitarAuto" 
                        :active-text="$t('app.active')" 
                        />
                    </div>
                    
                    <div class="mb-4" v-if="!isCreate && role === 'SuperAdministrador'">
                      <label for="id-switch-EnviarAvisosCertSinVincular" class="text-sm font-semibold text-secondary-600 block mb-2 flex flex-col">
                        {{$t('clients.avisos_sin_cert')}}
                        <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                      </label>
                      <el-switch 
                        id="id-switch-EnviarAvisosCertSinVincular"
                        :aria-label="$t('clients.avisos_sin_cert')"
                        class="switch-text break-normal both-switch mt-2" 
                        v-model="form.EnviarAvisosCertSinVincular" 
                        :active-text="$t('companies.active')"/>
                    </div>
                    
                    <div class="mb-4" v-if="!isCreate && (role === 'SuperAdministrador' || form.EnviarAvisosCertSinVincular)">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('clients.avisos_sin_cert_mails')}}
                        <el-form-item prop="EmailsAvisosCertSinVincular">
                          <el-input
                            clearable
                            class="w-full"
                            v-model="form.EmailsAvisosCertSinVincular"
                            maxlength='500'
                          />
                        </el-form-item>
                      </label>
                    </div>

                </template>
              </base-collapsible-form>

             <base-collapsible-form 
                ref="baseCollapsibleConfigUsers" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{msgHeaderConfigUsers}}</h2>
                </template>
                <template slot="content">

                   <div class="mb-4">
                    <label for="id-switch-VincularUsuariosGrupoGestorNEOs" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('clients.config_link_user_pool')}}
                      <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                    </label>
                    <el-switch 
                      id="id-switch-VincularUsuariosGrupoGestorNEOs"
                      :aria-label="$t('clients.config_link_user_pool')"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="form.VincularUsuariosGrupoGestorNEOs" 
                      :active-text="$t('app.active')" 
                      />
                  </div>

                  <div class="lg:mb-2">
                    <accessible-el-select
                      prop="mesesUserPass"
                      v-model="form.mesesUserPass"
                      :options="mesesUserPassCaduc"
                      id-prefix="clients"
                    >
                      <template #label>
                        <base-obligatory-icon />
                        {{ $t('clients.mesesUserPass') }}
                      </template>
                    </accessible-el-select>
                  </div>
                  
                  <div class="mb-6">
                    <div class="flex flex-col lg:flex-row lg:space-x-4">
                      <div class="mb-4 lg:mb-0 w-full" v-if="hasModuleDobleFactor && !isCreate">
                        <label for="id-switch-RequiereOTP" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                          {{$t('configurations.client_config_otp')}}
                          <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                        </label>
                        <el-switch 
                          id="id-switch-RequiereOTP"
                          :aria-label="$t('configurations.client_config_otp')"
                          class="switch-text break-normal both-switch mt-2" 
                          v-model="form.RequiereOTP"
                          :active-text="$t('app.active')" 
                        />
                      </div>
                      <div class="w-full">
                        <label for="id-switch-CambioPassPrimerAcceso" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                          {{$t('configurations.client_config_first_access')}}
                          <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                        </label>
                        <el-switch 
                          id="id-switch-CambioPassPrimerAcceso"
                          :aria-label="$t('configurations.client_config_first_access')"
                          class="switch-text break-normal both-switch mt-2" 
                          v-model="form.CambioPassPrimerAcceso"
                          :active-text="$t('app.active')" 
                          />
                      </div>
                    </div>
                  </div>

                </template>
              </base-collapsible-form>

            <div v-if="isCreate">
              <base-collapsible-form 
                ref="baseCollapsibleConfigUserInitial" 
                class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{"Datos de usuario web inicial"}}</h2>
                </template>
                <template slot="content">
                  <div v-if="isCreate" class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('configurations.username')}}
                        <el-form-item prop="username">
                          <el-input
                            :disabled="!isCreate"
                            clearable
                            class="w-full"
                            v-model="form.username"
                            maxlength='50'
                          />
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                  <div v-if="isCreate" class="lg:mb-2">
                    <div class="mandatory">
                      <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="isCreate"/>{{$t('configurations.email')}}
                        <el-form-item prop="email">
                          <el-input
                            :disabled="!isCreate"
                            clearable
                            class="w-full"
                            v-model="form.email"
                            maxlength='255'
                            autocomplete="email"
                          />
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                  <div v-if="isCreate" class="lg:mb-2">
                    <AccessibleElSelect
                      v-model="form.tipoAuth"
                      prop="tipoAuth"
                      :options="tiposAuthForAccessibleSelect"
                      :withFormItem="true"
                      id-prefix="client"
                    >
                      <template slot="label"><base-obligatory-icon v-if="isCreate"/>{{$t('configurations.tipo_auth')}}</template>
                    </AccessibleElSelect>
                  </div>
                  <div v-if="isCreate" class="mb-2 lg:mb-4">
                    <!-- <div class="flex flex-row"> -->
                    <div class="flex flex-col lg:flex-row lg:space-x-4">
                      <div class="flex flex-row items-center mb-4 lg:mb-0">
                        <label for="id-switch-verTodoStatuses" class="sr-only">
                          {{$t('configurations.ver_todo_statuses')}}. {{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}
                        </label>
                        <el-switch 
                          id="id-switch-verTodoStatuses"
                          :aria-label="$t('configurations.ver_todo_statuses')"
                          class="switch-text break-normal both-switch" 
                          v-model="form.verTodoStatuses" 
                          :active-text="$t('configurations.ver_todo_statuses')"/>
                        <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                      </div>
                      <div class="flex flex-row items-center mb-4 lg:mb-0">
                        <label for="id-switch-verTodoCompanies" class="sr-only">
                          {{$t('configurations.ver_todo_companies')}}. {{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}
                        </label>
                        <el-switch 
                          id="id-switch-verTodoCompanies"
                          :aria-label="$t('configurations.ver_todo_companies')"
                          class="switch-text break-normal both-switch" 
                          v-model="form.verTodoCompanies" 
                          :active-text="$t('configurations.ver_todo_companies')"/>
                        <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                      </div>
                    </div>
                  </div>
                  
                  <div v-if="isCreate" class="mb-6">
                    <div class="flex flex-col lg:flex-row lg:space-x-4">
                      <div class="flex flex-row items-center mb-4 lg:mb-0">
                        <label for="id-switch-Activo" class="sr-only">
                          {{$t('app.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                        </label>
                        <el-switch 
                          id="id-switch-Activo"
                          :aria-label="$t('app.active')"
                          class="switch-text break-normal" 
                          v-model="form.Activo" 
                          :active-text="$t('app.active')">
                        </el-switch>
                      </div>
                    </div>
                  </div>

                  <div v-if="isCreate && this.form.tipoAuth !== 1 && this.form.tipoAuth !== 3" class="lg:mb-4">
                    <div class="lg:mb-2">
                      <base-password-form-item v-model="form.password" autocomplete="new-password" ref="client-base-password-form-item" />
                      <base-password-form-item v-model="form.repeat_password" :password="form.password" autocomplete="new-password" repeat ref="client-base-password-form-item-repeat"/>
                    </div>
                  </div>
                </template>
              </base-collapsible-form>
            </div>

            <div v-if="!isCreate">
             <base-collapsible-form 
              ref="baseCollapsibleWhiteMetadata" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <div class="flex items-center mt-4 mb-4">
                    <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.config_admin_white_list_metadatas')}}</h2>
                    <base-tooltip-icon 
                      size="sm" 
                      :content="$t('tooltip.client.contentTooltipMetadataList')" 
                      class="ml-2"/>
                  </div>
                </template>
                <template slot="content">
                 <el-table
                  ref="whitelistmetadata"
                  :data="formUnwatchable.ListaBlancaMetadatos"
                  style="width: 100%"
                  max-height="250">
                  <el-table-column
                    prop="Nombre"
                    label="Nombre"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="Tipo"
                    label="Tipo"
                    show-overflow-tooltip
                    width="150"
                    >
                  </el-table-column>
                  <el-table-column
                    prop="actions"
                    width="120"
                    align="center"
                    label="Acciones">
                    <template slot-scope="scope">
                    <div class="flex flex-row justify-end">
                      <base-button-icon 
                        v-if="scope.row.EsLista"
                        @click="addValueToListMetadataToggleDialog(scope)" name="editpencil" mode="core" size="xs" 
                        ariaLabel="Editar metadato" />
                      <base-button-icon 
                        v-if="hasModuleImportaciones && scope.row.EsLista"
                        @click="toggleImport(scope)" name="import" mode="core" size="xs" 
                        ariaLabel="Importar metadato" />
                      <base-button-icon @click="deleteMetadatoAdicional(scope.row)" name="trash" mode="core" size="xs" 
                        ariaLabel="Eliminar metadato" />
                    </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="w-full float-right">
                  <base-button-responsive
                    mode="primary"
                    :text="$t('notificationFilter.new_metadata')"
                    @click="newMetadatoToggleDialog()"
                    icon="plus"
                    class="m-5 float-right"
                  />
                </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
              ref="baseCollapsibleWhiteEmails" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
                <template slot="headerRight">
                  <div class="flex items-center mt-4 mb-4">
                    <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.config_admin_white_list_emails')}}</h2>
                    <base-tooltip-icon 
                      size="sm" 
                      :content="$t('tooltip.client.contentTooltipWhiteList')" 
                      class="ml-2"/>
                  </div>
                </template>
                <template slot="content">
                 <el-table
                  ref="whitelistemails"
                  :data="formUnwatchable.ListaBlancaEmails"
                  style="width: 100%"
                  max-height="250"
                  :show-header="false">
                  <el-table-column
                    prop="Nombre"
                    label="Nombre"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="actions"
                    width="80"
                    align="center"
                    label="-">
                    <template slot-scope="scope">
                    <div class="flex flex-row">
                      <!-- <base-button-icon @click="editListaBlancaEmail(scope.row)" name="editpencil" mode="core" size="xs" /> -->
                      <base-button-icon @click="deleteListaBlancaEmail(scope.row)" name="trash" mode="core" size="xs" 
                        ariaLabel="Eliminar email de lista blanca" />
                    </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="w-full float-right">
                  <base-button-responsive
                    mode="primary"
                    :text="$t('clients.add_email')"
                    @click="newWhiteMailToggleDialog()"
                    icon="plus"
                    class="mb-5 mt-5 ml-2 float-right"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                  <base-button-responsive
                    mode="primary"
                    :text="$t('app.import_emails')"
                    @click="toggleImportEmail()"
                    icon="import"
                    class="mb-5 mt-5 ml-2 float-right"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                  <base-button-responsive
                    mode="primary"
                    :text="$t('app.export_excel')"
                    @click="exportExcelWhiteMail()"
                    icon="excelxls"
                    class="mb-5 mt-5 ml-2 float-right"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                  <base-button-responsive
                    v-if="visibleDeleteAllWhiteMail"
                    mode="primary"
                    :text="$t('app.delete_all')"
                    @click="deleteAllWhiteMailToggleDialog()"
                    icon="trash"
                    class="mb-5 mt-5 ml-2 float-right"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                </div>
                </template>
              </base-collapsible-form>

              <base-collapsible-form 
              ref="baseCollapsibleBlackEmails" 
              class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-6">
                <template slot="headerRight">
                  <div class="flex items-center mt-4 mb-4">
                    <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.config_admin_black_list_emails')}}</h2>
                    <base-tooltip-icon 
                      size="sm" 
                      :content="$t('tooltip.client.contentTooltipBlackList')" 
                      class="ml-2"/>
                  </div>
                </template>
                <template slot="content">
                 <el-table
                  ref="blacklistemails"
                  :data="formUnwatchable.ListaNegraEmails"
                  style="width: 100%"
                  max-height="250"
                  :show-header="false">
                  <el-table-column
                    prop="Nombre"
                    label="Nombre"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="actions"
                    width="80"
                    align="center"
                    label="-">
                    <template slot-scope="scope">
                    <div class="flex flex-row">
                      <!-- <base-button-icon @click="editListaNegraEmail(scope.row)" name="editpencil" mode="core" size="xs" /> -->
                      <base-button-icon @click="deleteListaNegraEmail(scope.row)" name="trash" mode="core" size="xs" 
                        ariaLabel="Eliminar email de lista negra" />
                    </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="w-full float-right">
                  <base-button-responsive
                    mode="primary"
                    :text="$t('clients.add_email')"
                    @click="newBlackMailToggleDialog()"
                    icon="plus"
                    class="m-5 float-right"
                  />
                </div>
                </template>
              </base-collapsible-form>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate"
            mode="primary"
            :text="$t('app.goto_users')"
            icon="user"
            @click="goToUsers"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate"
            mode="primary"
            :text="$t('app.goto_groups')"
            icon="group"
            @click="goToGroups"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate"
            mode="primary"
            :text="$t('app.goto_companies')"
            icon="company"
            @click="goToCompanies"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="!isCreate"
            mode="primary"
            :text="$t('app.goto_certificates')"
            icon="certificates"
            @click="goToCertificates"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="form.idTipoProvisionamiento === 1 && !form.FechaFacturacion && !isCreate && !form.activo"
            mode="primary"
            :text="$t('app.send_facturacion')"
            icon="mailsend"
            @click="submitForm('ruleForm', true)"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            v-if="form.PendienteConfigurar && role === 'SuperAdministrador'"
            mode="primary"
            :text="$t('app.cancel_wizard')"
            icon="settingscancel"
            @click="finalizarWizard()"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <BaseElDialog
        :title="$t('clients.delete_white_list_emails')"
        :visible.sync="showModalDeleteWhiteMail"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-neo')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDeleteWhiteMail }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-neo">
            <base-button class="w-full" @click="showModalDeleteWhiteMail = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {submitActionDeleteWhiteMail(); showModalDeleteWhiteMail = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <input-create-metadata-dialog
        :dialogOpen="showModalMetadato" 
        @toggleDialog="newMetadatoToggleDialog" 
        @applyDialog="applyNewMetadatoDialog"
        header="Añadir nuevo metadato" 
        />
      <input-modify-metadata-dialog
        :dialogOpen="showModalAddListMetadata" 
        @toggleDialog="addValueToListMetadataToggleDialog" 
        @applyDialog="applyModifyMetadatoDialog"
        header="Modificar valores" 
        :campoMetadato="actualMetadataSelected"
        :tipoMetadato="actualTypeSelectedNumber"
        :idCliente="this.id"
        />
      <input-text-mail-dialog 
        :dialogOpen="showModalWhiteMail" 
        @toggleDialog="newWhiteMailToggleDialog" 
        @applyDialog="applyNewWhiteMailDialog"
        header="Añadir nuevo email a la lista blanca" 
        headerValue="Nuevo email" 
        />
      <input-text-mail-dialog 
        :dialogOpen="showModalBlackMail" 
        @toggleDialog="newBlackMailToggleDialog" 
        @applyDialog="applyNewBlackMailDialog"
        header="Añadir nuevo email a la lista negra" 
        headerValue="Nuevo email" 
        />
        <BaseElDialog
          title="Inserción de metadato"
          :visible.sync="showModalTag"
            :close-on-click-modal="!isSelectDropdownOpen"
            @open="handleOpenModalDialog([
              'container-handleOpenModal-insert-metadata-body',
              'container-handleOpenModal-insert-metadata',
              ])"
            @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <div 
            class="overflow-x-hidden"
            ref="container-handleOpenModal-insert-metadata-body"
            >
            <el-form
              :model="formTag"
              ref="tagRules"
              :rules="tagRules"
            >
              <div class="lg:mb-2">
                <div>
                  <AccessibleElSelect
                    v-model="formTag.tag"
                    prop="tag"
                    :options="tagsForAccessibleSelect"
                    :withFormItem="true"
                    :group="true"
                    :loading="tagsLoading"
                    id-prefix="client"
                  >
                    <template slot="label"><base-obligatory-icon/>{{$t('app.tag_metadato')}}</template>
                  </AccessibleElSelect>
                </div>
              </div>
            </el-form>
          </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-insert-metadata">
              <base-button class="w-full" @click.stop.prevent="showModalTag = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click.stop.prevent="() => {insertTag('tagRules')}"/>
            </div>
          </template>
        </BaseElDialog>
        <import-generic-dialog
          :dialogOpen="showModalImport" 
          @toggleDialog="toggleImport" 
          @applyDialog="applyImport"
          @downloadTemplate="downloadTemplate"
          :getClientActive="false"
          header="Importación de valores a Metadato de tipo Lista" 
          />
          <import-generic-dialog
          :dialogOpen="showModalImportEmail" 
          @toggleDialog="toggleImportEmail" 
          @applyDialog="applyImportEmail"
          @downloadTemplate="downloadTemplateEmail"
          :getClientActive="false"
          header="Importación de Emails" 
          />
    </template>
  </detail-layout>
</template>

<script>
import { bus } from '@/main'

import axios from 'axios'
import moment from 'moment'
import { i18n } from '@/i18n'
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { newClient } from '@/services/clients/newClient'
import { getClient } from '@/services/clients/getClient' 
import { getModulosClienteId } from '@/services/clients/getModulosClienteId' 
import { getStoredDataDocs } from '@/services/clients/getStoredDataDocs'
import { getListMetadatas } from '@/services/clients/lists/getListMetadatas'
import { getWhiteListEmails } from '@/services/clients/lists/getWhiteListEmails'
import { getBlackListEmails } from '@/services/clients/lists/getBlackListEmails'
import { newListMetadatas } from '@/services/clients/lists/newListMetadatas' 
import { updateNameMetadata } from '@/services/clients/lists/updateNameMetadata' 
import { newWhiteListEmails } from '@/services/clients/lists/newWhiteListEmails'
import { newBlackListEmails } from '@/services/clients/lists/newBlackListEmails'
import { deleteListMetadatas } from '@/services/clients/lists/deleteListMetadatas'
import { deleteWhiteListEmails } from '@/services/clients/lists/deleteWhiteListEmails' 
import { deleteBlackListEmails } from '@/services/clients/lists/deleteBlackListEmails'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClientTemplate } from '@/services/clients/getClientTemplate' 
import { getWhiteMailExcel } from '@/services/clients/getWhiteMailExcel' 
import { deleteAllWhiteListEmails } from '@/services/clients/lists/deleteAllWhiteListEmails'

import { finalizarWizard } from '@/services/clients/finalizarWizard' 
import { sendFacturacion } from '@/services/clients/sendFacturacion' 
import { updateClient } from '@/services/clients/updateClient'
import { getPartners } from '@/services/clients/getPartners'
import { getClients } from '@/services/clients/getClients'
import { getTagsMetadatosCliente } from '@/services/clients/getTagsMetadatosCliente'
import { getServiceTypes } from '@/services/app/getServiceTypes'
import { MESES_USER_PASS_CADUC } from '@/config/meses-user-pass-caduc'
import { TIPOS_AUTH } from '@/config/tipos-auth'
import { TIPOS_HSM } from '@/config/tipos-hsm'
import { TIPOS_CLIENTE } from '@/config/tipos-cliente'
import { TIPOS_MAQUINAS_NUESTRAS } from '@/config/tipos-maquinas-nuestras'
// import { i18n } from '@/i18n'
import InputCreateMetadataDialog from '@/components/InputCreateMetadataDialog.vue'
import InputModifyMetadataDialog from '@/components/InputModifyMetadataDialog.vue'
import InputTextMailDialog from '@/components/InputTextMailDialog.vue'
import { email as emailRegex } from '@/utils/regex'
import BaseElDialog from '@/components/base/BaseElDialog.vue'

import ImportGenericDialog from '@/components/ImportGenericDialog.vue'
import { importValoresMetadato } from '@/services/configurations/imports/importValoresMetadato'
import { importListaBlancaEmailsCliente } from '@/services/configurations/imports/importListaBlancaEmailsCliente'
import { downloadTemplateValoresMetadato } from '@/services/configurations/imports/downloadTemplateValoresMetadato'
import { downloadTemplateListaBlancaEmails } from '@/services/configurations/imports/downloadTemplateListaBlancaEmails'

import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { dropdownState } from '@/state/dropdownState'
import BaseTooltipIcon from '../../components/base/BaseTooltipIcon.vue'

function isValidNumLicense (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 9999999) {
      return true
    }
  }
  return false
}
function isValidEmail (value) {
  return value.split(';').every(item => emailRegex.test(item))
}
function isValidDayEnd (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 30) {
      return true
    }
  }
  return false
}

export default {
  /* eslint-disable camelcase */
  name: 'client-detail',
  components: {
    DetailLayout,
    InputCreateMetadataDialog,
    InputModifyMetadataDialog,
    InputTextMailDialog,
    BaseElDialog,
    ImportGenericDialog,
    AccessibleElSelect,
    BaseTooltipIcon,
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      showGeneratePassword: false,
      searchView: false,
      activeName: 'es',
      localUserId: null,
      distribuidores: [],
      partners: [],
      gruposVigilante: [],
      tiposServicio: [],
      tiposHSM: TIPOS_HSM,
      tiposCliente: TIPOS_CLIENTE,
      tiposMaquinasNuestras: TIPOS_MAQUINAS_NUESTRAS,
      header: {
        title: 'DETALLE DE CLIENTE',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/clients'
      },
      formTag: {
        tag: null,
      },
      tags: [],
      tagsLoading: false,
      showModalTag: false,
      showModalMetadato: false,
      showModalAddListMetadata: false,
      actualMetadataSelected: '',
      actualTypeSelected: 0,
      showModalWhiteMail: false,
      showModalBlackMail: false,
      showModalImport: false,
      showModalImportEmail: false,
      showModalDeleteWhiteMail: false,
      processMessageDeleteWhiteMail: this.$i18n.t('clients.delete_white_list_emails_msg'),
      msgHeaderConfigMails: this.$i18n.t('clients.config_admin_mails'),
      msgHeaderConfigUsers: this.$i18n.t('clients.config_admin_users'),
      msgHeaderConfigLists: this.$i18n.t('clients.config_admin_lists'),
      tiposAuth: TIPOS_AUTH,
      listaIDsModulosClientes: [],
      form: this.getDefaultForm(),
      formUnwatchable: this.getDefaultFormUnwatchable(),
      stats: {
        StoredSpace: 0,
        NumNEOs: 0,
        NumSMS: 0,
        NumCompanies: 0,
        NumeroSedesxCIFEmpresas: 0,
        NumUsers: 0,
        NumNEOsTotal: 0,
        StoredSpaceTotal: 0,
        NumSMSTotal: 0,
        NumCompaniesTotal: 0,
        NumeroSedesxCIFEmpresasTotal: 0,
        NumUsersTotal: 0,
      },
      lastMetadatoImport: '',
      mesesUserPassCaduc: MESES_USER_PASS_CADUC,
      tooltipVerTodoStatuses: this.$i18n.t('tooltip.ver_todo_statuses'),
      tooltipVerTodoCompanies: this.$i18n.t('tooltip.ver_todo_companies'),
      tooltipActiveApoderadosAEAT: this.$i18n.t('tooltip.active_apoderados'),
      tagRules: {
        tag: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      },
      updateRules: {
        name: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        FechaAlta: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        TipoHSM: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        idTipoCliente: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        // MaquinasNuestras: [
        //   { validator: this.isGenericValidation, trigger: 'blur' },
        //   { validator: this.isGenericValidation, trigger: 'change' }
        // ],
        EmailsContacto: [
          { required: false, validator: this.isEmailMultipleValid, trigger: 'blur' }
        ],
        codigoExterno: [
          { validator: this.isCodigoExternoValid, trigger: 'change' }
        ],
        mesesUserPass: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        maxSizeZIP: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumNEOs: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: false, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        StoredSpace: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        NumSMS: [
          { required: false, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        NumLocations: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumCompanies: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumUsers: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumeroSedesxCIFEmpresas: [
          { required: false, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        EmailsAvisosCertSinVincular: [
          { required: false, validator: this.isEmailMultipleValid, trigger: 'blur' }
        ],
        DiasFechaFinTramite: [
          { required: false, validator: this.isDayValidEnd, trigger: 'blur' }
        ]
      },
      newRules: {
        name: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        EmailsContacto: [
          { required: false, validator: this.isEmailMultipleValid, trigger: 'blur' }
        ],
        codigoExterno: [
          { validator: this.isCodigoExternoValid, trigger: 'change' }
        ],
        username: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        email: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        ns: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        partnerId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        tipoAuth: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        mesesUserPass: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        grupoVigilanteId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        NumNEOs: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        StoredSpace: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        NumSMS: [
          { required: false, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
        NumLocations: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumCompanies: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumUsers: [
          { required: false, validator: this.isNumberValid, trigger: 'blur' }
        ],
        NumeroSedesxCIFEmpresas: [
          { required: false, validator: this.isNumberConnectionsValid, trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    isSelectDropdownOpen () {
      return dropdownState.isAnyDropdownOpen
    },
    visibleDeleteAllWhiteMail () {
      return this.formUnwatchable?.ListaBlancaEmails?.length > 0
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    hasModuleCustomDownloadZIP () {
      return this.$store.getters['auth/hasModuleCustomDownloadZIP'] && (this.listaIDsModulosClientes.includes(24) || this.role === 'Administrador')
    },
    hasModuleDescargaAdjuntosPrincipales () {
      return this.$store.getters['auth/hasModuleDescargaAdjuntosPrincipales'] && (this.listaIDsModulosClientes.includes(21) || this.role === 'Administrador')
    },
    hasPermissionEditVisiblity () {
      return this.$store.getters['auth/hasPermissionEditVisiblity']
    },
    hasModuleDobleFactor () {
      return this.$store.getters['auth/hasModuleDobleFactor'] && (this.listaIDsModulosClientes.includes(29) || this.role === 'Administrador')
    },
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasModuleImportaciones'] && (this.listaIDsModulosClientes.includes(23) || this.role === 'Administrador')
    },
    hasModuleNotificacionesTerceros () {
      return this.$store.getters['auth/hasModuleNotificacionesTerceros'] && (this.listaIDsModulosClientes.includes(3) || this.role === 'SuperAdministrador')
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    percentageNumNEOs: function () {
      if (this.stats.NumNEOs === 0 || this.stats.NumNEOsTotal === 0) return 0
      return Math.round((parseInt(this.stats.NumNEOs) * 100) / parseInt(this.stats.NumNEOsTotal)) 
    },
    percentageStoredSpace: function () {
      if (this.stats.StoredSpace === 0 || this.stats.StoredSpaceTotal === 0) return 0
      return Math.round((parseInt(this.stats.StoredSpace) * 100) / parseInt(this.stats.StoredSpaceTotal)) 
    },
    percentageNumSMS: function () {
      if (this.stats.NumSMS === 0 || this.stats.NumSMSTotal === 0) return 0
      return Math.round((parseInt(this.stats.NumSMS) * 100) / parseInt(this.stats.NumSMSTotal)) 
    },
    percentageNumCompanies: function () {
      if (this.stats.NumCompanies === 0 || this.stats.NumCompaniesTotal === 0) return 0
      return Math.round((parseInt(this.stats.NumCompanies) * 100) / parseInt(this.stats.NumCompaniesTotal)) 
    },
    percentageNumeroSedesxCIFEmpresas: function () {
      if (this.stats.NumeroSedesxCIFEmpresas === 0 || this.stats.NumeroSedesxCIFEmpresasTotal === 0) return 0
      return Math.round((parseInt(this.stats.NumeroSedesxCIFEmpresas) * 100) / parseInt(this.stats.NumeroSedesxCIFEmpresasTotal)) 
    },
    percentageNumUsers: function () {
      if (this.stats.NumUsers === 0 || this.stats.NumUsersTotal === 0) return 0
      return Math.round((parseInt(this.stats.NumUsers) * 100) / parseInt(this.stats.NumUsersTotal))
    },
    isGeneralLoading () {
      return this.$store.getters.isLoading
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : null
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    calcTotalPGNCIF () {
      if (!this.form.NumLocations || !this.form.NumCompanies) return 0
      return parseInt(this.form.NumLocations) * parseInt(this.form.NumCompanies)
    },
    partnersForAccessibleSelect () {
      return this.partners.map(partner => ({
        id: partner.Nombre,
        name: partner.Nombre,
        value: partner.Nombre
      }))
    },
    gruposVigilanteForAccessibleSelect () {
      return this.gruposVigilante.map(grupo => ({
        id: grupo.IdEmpresa,
        name: grupo.Nombre,
        value: grupo.IdEmpresa
      }))
    },
    tiposServicioForAccessibleSelect () {
      return this.tiposServicio.map(tipoServicio => ({
        id: tipoServicio.IdTipoServicio,
        name: tipoServicio.Descripcion,
        value: tipoServicio.IdTipoServicio
      }))
    },
    tiposHSMForAccessibleSelect () {
      return this.tiposHSM.map(tipoHSM => ({
        id: tipoHSM.id,
        name: tipoHSM.name,
        value: tipoHSM.id
      }))
    },
    tiposClienteForAccessibleSelect () {
      return this.tiposCliente.map(tipoCliente => ({
        id: tipoCliente.id,
        name: tipoCliente.name,
        value: tipoCliente.id
      }))
    },
    tiposMaquinasNuestrasForAccessibleSelect () {
      return this.tiposMaquinasNuestras.map(tipoMaquina => ({
        id: tipoMaquina.id,
        name: tipoMaquina.name,
        value: tipoMaquina.id
      }))
    },
    tiposAuthForAccessibleSelect () {
      return this.tiposAuth.map(tipo => ({
        id: tipo.id,
        name: tipo.name,
        value: tipo.id,
        disabled: tipo.disabled === true
      }))
    },
    tagsForAccessibleSelect () {
      return (this.tags || []).map(group => ({
        label: group.Tipo,
        options: (group.Metadatos || []).map(item => ({
          id: item.Tag,
          name: item.Descripcion,
          value: item.Tag
        }))
      }))
    },
    isLabelFraudeDesact () {
      return this.$store.getters['configurations/isLabelFraudeDesact']
    },
    disableActiveLibre () {
      return this.isCreate && this.$store.getters['auth/idTipoProvisionamientoDistribuidor'] === 1
    },
    disableTipoLibre () {
      return (
        ((this.role === 'SuperAdminDistribuidor' || this.role === 'AdminDistribuidor') && this.form?.idTipoProvisionamiento === 1) ||
        this.disableActiveLibre
      )
    },
    disableLicenciamiento () {
      return (this.form.activo || this.form.FechaFacturacion) &&
        !this.isCreate && 
        this.role !== 'SuperAdministrador' && 
        this.form.idTipoProvisionamiento === 1
    },
    actualTypeSelectedNumber () {
      return this.actualTypeSelected === 'Lista autoalimentable' ? 1
        : this.actualTypeSelected === 'Lista no autoalimentable' ? 2
          : 0
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.idDistribuidor': function (value, oldValue) {
      if (this.isCreate) {
        this.refreshGrupoVigilantes()
      }
    },
    showModalTag (newValue, oldValue) {
      if (!newValue) {
        this.formTag.tag = ''
      } else {
        this.handleGetTagsMetadatosCliente()
      }
    },
  },
  beforeDestroy () {
    this.cancelToken.cancel()
  },
  created: async function () {
    this.cancelToken = axios.CancelToken.source() 
    this.$store.commit('setIsLoading', true)
    const breadcrumbs = []
    breadcrumbs.push({
      path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
      name: this.$i18n.t('app.configurations')
    })
    
    if (this.role === 'SuperAdministrador') {
      const dataDistributors = await getDistributors()
      if (dataDistributors.blnError === true) {
        this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
      }
      this.distribuidores = dataDistributors.Distribuidores
    }
    if (this.disableActiveLibre) {
      this.form.activo = false
    } 

    if (!this.isCreate && this.role !== 'Administrador') {
      const dataModulosCliente = await getModulosClienteId({ idCliente: this.id })
      if (dataModulosCliente.blnError === false) {
        this.listaIDsModulosClientes = dataModulosCliente.Respuesta
      } else {
        this.doFeedback(dataModulosCliente.msgError + ' [Código de error: ' + dataModulosCliente.codError + ']')
      }
    }

    const dataClients = await getPartners()
    if (dataClients.blnError === false) {
      this.partners = dataClients.TipoServ
    } else {
      this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
    }

    await this.refreshGrupoVigilantes()

    const dataServiceTypes = await getServiceTypes()
    if (dataServiceTypes.blnError === false) {
      this.tiposServicio = dataServiceTypes.TipoServ
    } else {
      this.doFeedback(dataServiceTypes.msgError + ' [Código de error: ' + dataServiceTypes.codError + ']')
    }

    // this.handleGetTagsMetadatosCliente()

    if (!this.isCreate) {
      await this.downloadData(this.id)
      breadcrumbs.push({
        path: 'configurations/clients',
        name: this.$i18n.t('app.clients')
      })
      breadcrumbs.push({ path: '', name: this.form.name })
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
      this.downloadListMetada()
      this.downloadListwhiteEmail()
      this.downloadListBlackEmail()
    } else {
      breadcrumbs.push({
        path: '',
        name: this.$i18n.t('clients.new_client')
      })
      await this.refreshFormWithTemplate()
      this.$store.commit('setIsLoading', false)
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    this.$refs.baseCollapsibleDatosGeneral.toggle()
    this.$refs.baseCollapsibleConfigGeneral.toggle()
    if (this.isCreate) {
      this.$refs.baseCollapsibleLicenciamiento.toggle()
      this.$refs.baseCollapsibleConfigMails.toggle()
      this.$refs.baseCollapsibleConfigUsers.toggle()
      this.$refs.baseCollapsibleConfigUserInitial.toggle()
    }
    this.resetControlFormChanges()
  },
  methods: {
    deleteAllWhiteMailToggleDialog () {
      this.showModalDeleteWhiteMail = !this.showModalDeleteWhiteMail
    },
    submitActionDeleteWhiteMail: async function () {
      this.$store.commit('app/setLoading', true)
      try {
        await this.exportExcelWhiteMail()
        const params = { idCliente: this.id } 
        const response = await deleteAllWhiteListEmails(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadListwhiteEmail()
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    exportExcelWhiteMail: async function () {
      this.$store.commit('app/setLoading', true)
      try {
        const params = { idCliente: this.id } 
        const response = await getWhiteMailExcel(params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'lista-blanca-emails.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    isDayValidEnd: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDayEnd(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso_fin_tramite'), callback)
      } else {
        callback()
      }
    },
    toggleImport (scope = null) {
      this.lastMetadatoImport = scope?.row?.Nombre
      this.showModalImport = !this.showModalImport
    },
    toggleImportEmail () {
      this.showModalImportEmail = !this.showModalImportEmail
    },
    applyImport: async function (file, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importValoresMetadato(file, { idCliente: this.id, Campo: this.lastMetadatoImport })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImport() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportEmail: async function (file) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importListaBlancaEmailsCliente(file, { idCliente: this.id })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportEmail() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplate: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateValoresMetadato()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-valores-metadato.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateEmail: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateListaBlancaEmails()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-emails.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    handleGetTagsMetadatosCliente: async function () {
      if (this.hasModuleCustomDownloadZIP && !this.isCreate) {
        this.tagsLoading = true
        this.tags = []
        // await new Promise(resolve => setTimeout(resolve, 2000))
        const dataMetadatosCliente = await getTagsMetadatosCliente({ idCliente: this.id })
        if (dataMetadatosCliente.blnError === false) {
          this.tags = dataMetadatosCliente.Respuesta
        } else {
          this.doFeedback(dataMetadatosCliente.msgError + ' [Código de error: ' + dataMetadatosCliente.codError + ']')
        }
        this.tagsLoading = false
      }
    },
    toggleInsertTag () {
      this.showModalTag = !this.showModalTag
    },
    insertTag: async function (ruleForm) {
      try {
        this.$refs[ruleForm].validate(async valid => {
          if (valid) {
            let newValue = ''
            if (this.form.renameZip) newValue = this.form.renameZip
            newValue += this.formTag.tag
            this.form.renameZip = newValue
            this.showModalTag = false
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      } catch (error) {
        console.log(error)
        this.doFeedback()
      }
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    refreshGrupoVigilantes: async function () {
      if (this.isCreate) this.form.grupoVigilanteId = null
      this.gruposVigilante = []
      const params = { grupoEmpresas: true }
      if (this.form.idDistribuidor) params.idDistribuidor = this.form.idDistribuidor
      const dataGruposVigilante = await getClients(params)
      if (dataGruposVigilante.blnError === false) {
        this.gruposVigilante = dataGruposVigilante.Empresas
      } else {
        this.doFeedback(dataGruposVigilante.msgError + ' [Código de error: ' + dataGruposVigilante.codError + ']')
      }
      this.resetControlFormChanges()
    },
    refreshFormWithTemplate: async function () {
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor') {
        const template = await getClientTemplate()
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        }
        this.setTemplate(template.respuesta)
      }
    },
    deleteMetadatoAdicional: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Campo: row.Nombre, idCliente: this.id }
        const response = await deleteListMetadatas(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newMetadatoToggleDialog () {
      this.showModalMetadato = !this.showModalMetadato
    },
    addValueToListMetadataToggleDialog (scope) {
      this.actualMetadataSelected = scope?.row?.Nombre || ''
      this.actualTypeSelected = scope?.row?.Tipo || 0
      this.showModalAddListMetadata = !this.showModalAddListMetadata
    },
    deleteListaBlancaEmail: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Email: row.Nombre, idCliente: this.id }
        const response = await deleteWhiteListEmails(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadListwhiteEmail()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newWhiteMailToggleDialog () {
      this.showModalWhiteMail = !this.showModalWhiteMail
    },
    deleteListaNegraEmail: async function (row) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Email: row.Nombre, idCliente: this.id }
        const response = await deleteBlackListEmails(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadListBlackEmail()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    newBlackMailToggleDialog () {
      this.showModalBlackMail = !this.showModalBlackMail
    },
    applyNewMetadatoDialog: async function (metadato) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: metadato.value, 
          Tipo: metadato.type,
          idCliente: this.id,
        }
        const response = await newListMetadatas(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.newMetadatoToggleDialog()
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyModifyMetadatoDialog: async function (metadato) {
      try {
        this.$store.commit('setIsLoading', true)
        metadato.idCliente = this.id
        const response = await updateNameMetadata(metadato)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.addValueToListMetadataToggleDialog()
          this.downloadListMetada()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyNewWhiteMailDialog: async function (email) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Email: email, idCliente: this.id }
        const response = await newWhiteListEmails(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.newWhiteMailToggleDialog()
          this.downloadListwhiteEmail()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyNewBlackMailDialog: async function (email) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { Email: email, idCliente: this.id }
        const response = await newBlackListEmails(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.newBlackMailToggleDialog()
          this.downloadListBlackEmail()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadListMetada: async function () {
      try {
        const payload = { idCliente: this.id ?? -1 }
        const result = await getListMetadatas(payload)
        if (result.blnError === true) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.formUnwatchable.ListaBlancaMetadatos = result.Respuesta.map(x => ({ Nombre: x.Campo, EsLista: x.EsLista, Tipo: x.Tipo }))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        // this.resetControlFormChanges()
      }
    },
    downloadListwhiteEmail: async function () {
      try {
        const payload = { idCliente: this.id ?? -1 }
        const result = await getWhiteListEmails(payload)
        if (result.blnError === true) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.formUnwatchable.ListaBlancaEmails = result.Respuesta.map(x => ({ Nombre: x }))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        // this.resetControlFormChanges()
      }
    },
    downloadListBlackEmail: async function () {
      try {
        const payload = { idCliente: this.id ?? -1 }
        const result = await getBlackListEmails(payload)
        if (result.blnError === true) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.formUnwatchable.ListaNegraEmails = result.Respuesta.map(x => ({ Nombre: x }))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        // this.resetControlFormChanges()
      }
    },
    getDataParams () {
      const data = { filters: [] }
      data.filters.push({ type: 'cliente', data: { label: this.form.name, id: -1 } })
      return data
    },
    goToUsers () {
      const data = this.getDataParams()
      this.$router.push({ name: 'configurations/users', params: { data: data } })
    },
    goToGroups () {
      const data = this.getDataParams()
      this.$router.push({ name: 'configurations/groups', params: { data: data } })
    },
    goToCompanies () {
      const data = this.getDataParams()
      this.$router.push({ name: 'companies', params: { data: data } })
    },
    goToCertificates () {
      const data = this.getDataParams()
      this.$router.push({ name: 'certificates', params: { data: data } })
    },
    customColorMethod: function (percentage) {
      if (percentage >= 80) {
        return '#FF382C'
      } else {
        if (this.darkMode) return 'var(--primary-400)'
        else return 'var(--primary-800)'
      }
    },
    isNumberValid: function (rule, value, callback) {
      if ((!value || value === '')) {
        if (rule.field === 'NumSMS' || rule.field === 'maxSizeZIP') {
          callback()
        }
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      } else if (!isValidNumLicense(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.number'), callback)
      } else {
        callback()
      }
    },
    isNumberConnectionsValid: function (rule, value, callback) {
      if (!value || value === '') {
        // return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
        callback()
      } else if (!isValidNumLicense(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.num_max_7'), callback)
      // } else if (value > this.calcTotalPGNCIF) {
      //   this.doAriaLiveAndReturnCallback(i18n.t('validation.template.num_license'), callback)
      } else {
        callback()
      }
    },
    getDefaultForm: function () {
      return {
        name: '',
        EmailsContacto: '',
        codigoExterno: '',
        renameZip: '',
        configDownloadZIP: false,
        configZipMailDownload: false,
        configZipMailVinc: false,
        configZipMailManual: false,
        maxSizeZIP: null,
        FechaAlta: null,
        ns: '',
        username: '',
        email: '',
        idDistribuidor: null,
        idTipoProvisionamiento: null,
        partnerId: null,
        password: '',
        repeat_password: '',
        tipoServicio: '',
        TipoHSM: null,
        idTipoCliente: null,
        MaquinasNuestras: null,
        FechaMigracionSolpheo: null, 
        mesesUserPass: 0,
        grupoVigilanteId: null,
        verTodoStatuses: true,
        verTodoCompanies: true,
        OcultarInformacionEmpresasCertificados: false,
        EnviarCorreoSoloDescargaAutomatica: false,
        TercerosAvanzado: false,
        OcultarEnlaceDescarga: false,
        TramitarDiligenciasContestadas: false,
        Activo: true,
        tipoAuth: null,
        StoredSpace: 500,
        NumNEOs: 3000,
        NumSMS: null,
        NumLocations: 5,
        NumCompanies: 10,
        NumUsers: 20,
        NumeroSedesxCIFEmpresas: null,
        activo: true,
        editVisilibity: false,
        DescargarSoloAdjuntosPrincipales: false,
        GestionarListaBlancaGrupos: false,
        FechaFacturacion: null,
        PendienteConfigurar: false,
        VincularUsuariosGrupoGestorNEOs: false,
        mailsGroupCompanies: true,
        TramitarAuto: false,
        EnviarAvisosCertSinVincular: false,
        EmailsAvisosCertSinVincular: '',
        daysGroupsCompanies: true,
        mailsTo: false,
        apoderadosAutomaticosAEAT: false,
        descargarAcusePDF: false,
        DiasFechaFinTramite: null,

        RequiereOTP: false,
        CambioPassPrimerAcceso: false,
      }
    },
    getDefaultFormUnwatchable () {
      return {
        ListaBlancaMetadatos: [],
        ListaBlancaEmails: [],
        ListaNegraEmails: [],
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      if (!emailRegex.test(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
    isEmailMultipleValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email_multiple'), callback)
      } else {
        callback()
      }
    },
    isCodigoExternoValid: function (rule, value, callback) {
      const re = /["<>|:*?\\/]/
      // if (!value) {
      //   return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      // } else {
      if (re.test(value)) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.codigo_ext.chars'), callback)
      } else {
        callback()
      }
      // }
    },
    sendFacturacionHandler: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const params = { idCliente: this.id }
        const response = await sendFacturacion(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Enviado a facturación correctamente', 'success')
          this.form.FechaFacturacion = moment(new Date()).format('DD-MM-yyyy HH:mm')
        }
      } catch (error) {
        this.doFeedback()
      }
      this.$store.commit('setIsLoading', false)
    },
    submitForm: function (formName, sendFactura = false) {
      if (this.isCreate) {
        this.newClientHandler(formName)
      } else {
        this.updateClientHandler(formName, sendFactura)
      }
    },
    finalizarWizard: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const params = { idCliente: this.id }
        const response = await finalizarWizard(params)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Wizard finalizado correctamente', 'success')
          this.form.PendienteConfigurar = false
          this.resetControlFormChanges()
        }
      } catch (error) {
        this.doFeedback()
      }
      this.$store.commit('setIsLoading', false)
    },
    newClientHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const payload = {
            NumeroSerieEmpresa: this.form.ns,
            Nombre: this.form.name,
            CodigoExterno: this.form.codigoExterno,
            EmailsContacto: this.form.EmailsContacto,
            idDistribuidor: this.form.idDistribuidor,
            Partner: this.form.partnerId,
            primerUsuario: {
              Nombre: this.form.username,
              Email: this.form.email,
              Password: this.form.password,
              VerTodoEstados: this.form.verTodoStatuses,
              VerTodoEmpresas: this.form.verTodoCompanies,
              Activo: this.form.Activo,
              idTipoAutenticacion: this.form.tipoAuth,
            },
            MesesUserPass: this.form.mesesUserPass,
            idGrupoVigilante: this.form.grupoVigilanteId,
            EspacioTotal: this.form.StoredSpace,
            NumeroNotificacionesAnuales: this.form.NumNEOs,
            NumeroSMS: this.form.NumSMS,
            NumeroSedes: this.form.NumLocations,
            NumeroCIFEmpresas: this.form.NumCompanies,
            NumeroUsuarios: this.form.NumUsers,
            NumeroSedesxCIFEmpresas: this.form.NumeroSedesxCIFEmpresas,
            Activo: this.form.activo,
            DescargarSoloAdjuntosPrincipales: this.form.DescargarSoloAdjuntosPrincipales,
            GestionarListaBlancaGrupos: this.form.GestionarListaBlancaGrupos,
            VincularUsuariosGrupoGestorNEOs: this.form.VincularUsuariosGrupoGestorNEOs,
            EnviarMailGruposNoPropietarios: this.form.mailsGroupCompanies,
            TramitarAuto: this.form.TramitarAuto,
            GestionarDiasAvisosGrupos: this.form.daysGroupsCompanies,
            EnviarMailCopiaOculta: this.form.mailsTo,
            ApoderadosAutomaticosAEAT: this.form.apoderadosAutomaticosAEAT,
            DescargarAcusePDF: this.form.descargarAcusePDF,
            RequiereOTP: this.form.RequiereOTP,
            CambioPassPrimerAcceso: this.form.CambioPassPrimerAcceso,
          }
          const response = await newClient(payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Datos guardados correctamente', 'success')
            this.resetForm()
            this.form = this.getDefaultForm()
            this.formUnwatchable = this.getDefaultFormUnwatchable()
            if (this.disableActiveLibre) {
              this.form.activo = false
            } 
            await this.refreshFormWithTemplate()
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    updateClientHandler: async function (formName, sendFactura = false) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const payload = {
            IdEmpresa: 0,
            NumeroSerieEmpresa: '',
            Nombre: this.form.name,
            CodigoExterno: this.form.codigoExterno,
            EmailsContacto: this.form.EmailsContacto,
            RenombradoZIP: this.form.renameZip,
            AdjuntarZIP: this.form.configDownloadZIP,
            EnviarZipAvisoDescargaNotificacion: this.form.configZipMailDownload,
            EnviarZipAvisoNotificacionVinculadaEnlace: this.form.configZipMailVinc,
            EnviarZipAvisoNotificacionEnvioManual: this.form.configZipMailManual,
            AdjuntoEmailMaxSize: this.form.maxSizeZIP,
            FechaAlta: this.form.FechaAlta ? moment(this.form.FechaAlta).format('YYYY-MM-DD[T00:00:00]') : null,
            idPartner: 0,
            MesesUserPass: this.form.mesesUserPass,
            EspacioTotal: this.disableLicenciamiento ? null : this.form.StoredSpace,
            NumeroNotificacionesAnuales: this.disableLicenciamiento ? null: this.form.NumNEOs,
            NumeroSMS: this.disableLicenciamiento ? null : this.form.NumSMS,
            NumeroSedes: this.disableLicenciamiento ? null : this.form.NumLocations,
            NumeroCIFEmpresas: this.disableLicenciamiento ? null : this.form.NumCompanies,
            NumeroUsuarios: this.disableLicenciamiento ? null : this.form.NumUsers,
            NumeroSedesxCIFEmpresas: this.disableLicenciamiento ? null : this.form.NumeroSedesxCIFEmpresas,
            OcultarInformacionEmpresasCertificados: this.form.OcultarInformacionEmpresasCertificados,
            EnviarCorreoSoloDescargaAutomatica: this.form.EnviarCorreoSoloDescargaAutomatica,
            TercerosBasico: this.hasModuleNotificacionesTerceros ? !this.form.TercerosAvanzado : null,
            OcultarEnlaceDescarga: this.form.OcultarEnlaceDescarga,
            TramitarDiligenciasContestadas: this.form.TramitarDiligenciasContestadas,
            Activo: this.disableTipoLibre ? null : this.form.activo,
            PermitirEdicionPermisos: this.form.editVisilibity,
            DescargarSoloAdjuntosPrincipales: this.form.DescargarSoloAdjuntosPrincipales,
            GestionarListaBlancaGrupos: this.form.GestionarListaBlancaGrupos,
            VincularUsuariosGrupoGestorNEOs: this.form.VincularUsuariosGrupoGestorNEOs,
            EnviarMailGruposNoPropietarios: this.form.mailsGroupCompanies,
            TramitarAuto: this.form.TramitarAuto,
            EnviarAvisosCertSinVincular: this.form.EnviarAvisosCertSinVincular,
            EmailsAvisosCertSinVincular: this.form.EmailsAvisosCertSinVincular,
            GestionarDiasAvisosGrupos: this.form.daysGroupsCompanies,
            EnviarMailCopiaOculta: this.form.mailsTo,
            ApoderadosAutomaticosAEAT: this.form.apoderadosAutomaticosAEAT,
            DescargarAcusePDF: this.form.descargarAcusePDF,
            DiasFechaFinTramite: parseInt(this.form.DiasFechaFinTramite),
            RequiereOTP: this.form.RequiereOTP,
            CambioPassPrimerAcceso: this.form.CambioPassPrimerAcceso,
            idTipoHSM: this.form.TipoHSM,
            idTipoCliente: this.form.idTipoCliente,
            MaquinasNuestras: this.form.MaquinasNuestras,
            FechaMigracionSolpheo: this.form.FechaMigracionSolpheo ? moment(this.form.FechaMigracionSolpheo).format('YYYY-MM-DD[T00:00:00]') : null,
          }
          const response = await updateClient({ idEmpresa: this.$route.params.id }, payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.setAutoMinMaxNumConexiones()
            this.doFeedback('Datos guardados correctamente', 'success')
            this.updateView()
            this.$store.commit('app/setheaderBreadCrumb', this.form.name)
            if (sendFactura) {
              await this.sendFacturacionHandler()
            }
            await this.downloadLicense()
            this.resetControlFormChanges()
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    setAutoMinMaxNumConexiones () {
      const numTotal = parseInt(this.form.NumLocations) * parseInt(this.form.NumCompanies)
      if (this.form.NumeroSedesxCIFEmpresas) {
        const numActual = parseInt(this.form.NumeroSedesxCIFEmpresas)
        // Max
        if (numActual > numTotal) {
          this.form.NumeroSedesxCIFEmpresas = numTotal
        }
        // Min
        if (numActual < parseInt(this.form.NumCompanies)) {
          this.form.NumeroSedesxCIFEmpresas = this.form.NumCompanies
        }
      } else {
        this.form.NumeroSedesxCIFEmpresas = numTotal
      }
      this.resetControlFormChanges()
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/clients' })
    },
    downloadData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idEmpresa: id
        }
        client = await getClient(params, this.cancelToken)
        this.setClient(client.empresa)
        // Datos Almacenamiento
        await this.downloadLicense()
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Petición cancelada')
        } else {
          this.doFeedback()
          console.log(error)
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    downloadLicense: async function () {
      if (!this.id) return
      const params = { idCliente: this.id }
      try {
        const dataAlmacenamiento = await getStoredDataDocs(params)
        if (dataAlmacenamiento.blnError === false) {
          this.stats.NumCompanies = dataAlmacenamiento.NumeroCIFEmpresas ? dataAlmacenamiento.NumeroCIFEmpresas : 0
          this.stats.NumUsers = dataAlmacenamiento.NumeroUsuarios ? dataAlmacenamiento.NumeroUsuarios : 0
          this.stats.NumeroSedesxCIFEmpresas = dataAlmacenamiento.NumeroSedesxCIFEmpresas ? dataAlmacenamiento.NumeroSedesxCIFEmpresas : 0
          this.stats.StoredSpace = dataAlmacenamiento.EspacioOcupado ? dataAlmacenamiento.EspacioOcupado : 0
          this.stats.NumNEOs = dataAlmacenamiento.NumeroNotificacionesAnuales ? dataAlmacenamiento.NumeroNotificacionesAnuales : 0
          this.stats.NumSMS = dataAlmacenamiento.SMSUsados ? dataAlmacenamiento.SMSUsados : 0

          this.stats.NumCompaniesTotal = dataAlmacenamiento.NumeroCIFEmpresasTotal ? dataAlmacenamiento.NumeroCIFEmpresasTotal : 0
          this.stats.NumUsersTotal = dataAlmacenamiento.NumeroUsuariosTotal ? dataAlmacenamiento.NumeroUsuariosTotal : 0
          this.stats.NumeroSedesxCIFEmpresasTotal = dataAlmacenamiento.NumeroSedesxCIFEmpresasTotal ? dataAlmacenamiento.NumeroSedesxCIFEmpresasTotal : 0
          this.stats.StoredSpaceTotal = dataAlmacenamiento.EspacioTotal ? dataAlmacenamiento.EspacioTotal : 0
          this.stats.NumNEOsTotal = dataAlmacenamiento.NumeroNotificacionesAnualesTotal ? dataAlmacenamiento.NumeroNotificacionesAnualesTotal : 0
          this.stats.NumSMSTotal = dataAlmacenamiento.SMSTotal ? dataAlmacenamiento.SMSTotal : 0
        } else {
          this.doFeedback(dataAlmacenamiento.msgError + ' [Código de error: ' + dataAlmacenamiento.codError + ']')
        }
      } catch (error) {
        this.doFeedback()
      }
    },
    setTemplate (client) {
      this.form.NumNEOs = client.NumeroNotificacionesAnuales ? client.NumeroNotificacionesAnuales : 0
      this.form.StoredSpace = client.EspacioTotal ? client.EspacioTotal : 0
      this.form.NumSMS = client.NumeroSMS ? client.NumeroSMS : 0
      this.form.NumLocations = client.NumeroSedes ? client.NumeroSedes : 0
      this.form.NumCompanies = client.NumeroCIFEmpresas ? client.NumeroCIFEmpresas : 0
      this.form.NumUsers = client.NumeroUsuarios ? client.NumeroUsuarios : 0
      this.form.NumeroSedesxCIFEmpresas = client.NumeroSedesxCIFEmpresas ? client.NumeroSedesxCIFEmpresas : null

      this.form.mailsGroupCompanies = client.EnviarMailGruposNoPropietarios 
      this.form.TramitarAuto = client.TramitarAuto
      this.form.daysGroupsCompanies = client.GestionarDiasAvisosGrupos 
      this.form.mailsTo = client.EnviarMailCopiaOculta

      this.form.VincularUsuariosGrupoGestorNEOs = client.VincularUsuariosGrupoGestorNEOs
      this.form.mesesUserPass = client.MesesUserPass ? client.MesesUserPass : 0

      this.form.apoderadosAutomaticosAEAT = client.ApoderadosAutomaticosAEAT ? client.ApoderadosAutomaticosAEAT : false
      this.form.descargarAcusePDF = client.DescargarAcusePDF ? client.DescargarAcusePDF : false
      this.resetControlFormChanges()
    },
    setClient: function (client) {
      this.form.name = client.Nombre
      this.form.codigoExterno = client.CodigoExterno
      this.form.EmailsContacto = client.EmailsContacto
      this.form.renameZip = client.RenombradoZIP
      this.form.configDownloadZIP = client.AdjuntarZIP
      this.form.configZipMailDownload = client.EnviarZipAvisoDescargaNotificacion
      this.form.configZipMailVinc = client.EnviarZipAvisoNotificacionVinculadaEnlace
      this.form.configZipMailManual = client.EnviarZipAvisoNotificacionEnvioManual
      this.form.maxSizeZIP = client.AdjuntoEmailMaxSize
      this.form.FechaAlta = client.FechaAlta
      this.form.ns = client.NumeroSerieEmpresa
      this.form.idTipoProvisionamiento = client.idTipoProvisionamiento ? client.idTipoProvisionamiento : null
      if (!client.idDistribuidor) {
        this.distribuidores.unshift({ IdDistribuidor: -1, Nombre: 'ZeroComa' })
        this.form.idDistribuidor = -1
      } else {
        this.form.idDistribuidor = client.idDistribuidor
      }

      if (client.idPartner === null) {
        this.partners.unshift({ IdPartner: -1, Nombre: 'Sin Partner' })
        this.form.partnerId = 'Sin Partner'
      } else {
        this.form.partnerId = client.Partner
      }
      if (!client.idGrupoVigilante) {
        this.gruposVigilante.unshift({ IdEmpresa: -1, Nombre: 'Ninguno' })
        this.form.grupoVigilanteId = -1
      } else {
        this.form.grupoVigilanteId = client.idGrupoVigilante
      }
      if (client.idTipoServicio === undefined || client.idTipoServicio === null) {
        this.tiposServicio.unshift({ IdTipoServicio: -1, Descripcion: 'Sin tipo de servicio' })
        this.form.tipoServicio = -1
      } else {
        this.form.tipoServicio = client.idTipoServicio
      }
      this.form.TipoHSM = client.idTipoHSM
      this.form.idTipoCliente = client.idTipoCliente ? client.idTipoCliente : 0
      this.form.MaquinasNuestras = client.MaquinasNuestras
      this.form.FechaMigracionSolpheo = client.FechaMigracionSolpheo
      this.form.mesesUserPass = client.MesesUserPass ? client.MesesUserPass : 0
      
      this.form.NumNEOs = client.NumeroNotificacionesAnuales ? client.NumeroNotificacionesAnuales : 0
      this.form.StoredSpace = client.EspacioTotal ? client.EspacioTotal : 0
      this.form.NumSMS = client.NumeroSMS ? client.NumeroSMS : 0
      this.form.NumLocations = client.NumeroSedes ? client.NumeroSedes : 0
      this.form.NumCompanies = client.NumeroCIFEmpresas ? client.NumeroCIFEmpresas : 0
      this.form.NumUsers = client.NumeroUsuarios ? client.NumeroUsuarios : 0
      this.form.NumeroSedesxCIFEmpresas = client.NumeroSedesxCIFEmpresas ? client.NumeroSedesxCIFEmpresas : null
      this.form.OcultarInformacionEmpresasCertificados = !!client.OcultarInformacionEmpresasCertificados
      this.form.EnviarCorreoSoloDescargaAutomatica = !!client.EnviarCorreoSoloDescargaAutomatica
      this.form.TercerosAvanzado = this.hasModuleNotificacionesTerceros ? !client.TercerosBasico : null
      this.form.OcultarEnlaceDescarga = client.OcultarEnlaceDescarga
      this.form.TramitarDiligenciasContestadas = client.TramitarDiligenciasContestadas
      this.form.activo = client.Activo
      this.form.DescargarSoloAdjuntosPrincipales = client.DescargarSoloAdjuntosPrincipales
      this.form.GestionarListaBlancaGrupos = client.GestionarListaBlancaGrupos
      this.form.editVisilibity = client.PermitirEdicionPermisos
      this.form.FechaFacturacion =client.FechaFacturacion? moment(client.FechaFacturacion).format('DD-MM-yyyy HH:mm') : null 
      this.form.PendienteConfigurar = client.PendienteConfigurar ? client.PendienteConfigurar : false
      this.form.VincularUsuariosGrupoGestorNEOs = client.VincularUsuariosGrupoGestorNEOs
      this.form.mailsGroupCompanies = client.EnviarMailGruposNoPropietarios 
      this.form.TramitarAuto = client.TramitarAuto
      this.form.EnviarAvisosCertSinVincular = client.EnviarAvisosCertSinVincular
      this.form.EmailsAvisosCertSinVincular = client.EmailsAvisosCertSinVincular
      this.form.daysGroupsCompanies = client.GestionarDiasAvisosGrupos 
      this.form.mailsTo = client.EnviarMailCopiaOculta
      this.form.apoderadosAutomaticosAEAT = client.ApoderadosAutomaticosAEAT ? client.ApoderadosAutomaticosAEAT : false
      this.form.descargarAcusePDF = client.DescargarAcusePDF ? client.DescargarAcusePDF : false
      this.form.DiasFechaFinTramite = client.DiasFechaFinTramite !== null ? client.DiasFechaFinTramite : null
      this.form.CambioPassPrimerAcceso = !!client.CambioPassPrimerAcceso
      this.form.RequiereOTP = !!client.RequiereOTP
      this.resetControlFormChanges()
    },
    generatePassword: function () {
      this.showGeneratePassword = !this.showGeneratePassword
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
    }
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
.hideHScroll {
  overflow-x: hidden;
}
</style>

